<!-- 合约交易 盘口 -->
<template>
  <div class="codepath-container">
    <div class="block-header title-tab a-3-bd main-bg">
      <span class="tab" @click="switchBlock('D')" :class="shrinksDdpthNewShow === 'D' ? 'main-cl': 'gray-cl'">
        <!-- 委托列表 -->
        {{$t('futures.depth.text1')}}
        <span class="selected blue-bg" v-if="shrinksDdpthNewShow === 'D'"></span>
      </span>
      <span class="tab tab-rtwo" @click="switchBlock('T')" :class="shrinksDdpthNewShow === 'T' ? 'main-cl': 'gray-cl'">
        <!-- 实时成交 -->
        {{$t('futures.depth.text2')}}
        <span class="selected blue-bg" v-if="shrinksDdpthNewShow === 'T'"></span>
      </span>

      <div class="depath-class gray-cl gray-30-bd" v-if="shrinksDdpthNewShow === 'D'">
        <span class="hoverHide">
          <!-- 深度 -->
          {{$t('futures.depth.text4')}}
          {{ fixDepthNumber(depathList[activeDepat]) }}
          <!--<span class="triangle-down"></span>-->
          <svg-icon class='icon-triangle-down' icon-class="icon-triangle-down"></svg-icon>
        </span>
        <span class="hoverShow b-4-cl">
          <!-- 深度 -->
          {{$t('futures.depth.text4')}}
          {{ fixDepthNumber(depathList[activeDepat]) }}
          <!--<span class="triangle-down b-4-bd"></span>-->
          <svg-icon class='icon-triangle-down' icon-class="icon-triangle-down"></svg-icon>
        </span>
        <ul class="type-item a-21-bg">
          <template  >
            <li
              v-for="(item, index) in depathList"
              :key="index"
              :class="(activeDepat === index || depatHover === index) ? 'a-3-bg main-cl' : ''"
              @mouseenter="handMouseenter(index)"
              @mouseout="handMouseleave(index)"
              @click.stop="switchDepat(index)">
              {{ fixDepthNumber(item) }}
            </li>
          </template>
        </ul>
      </div>
    </div>

    <div class="tab-item" :class="{ 'is-show': shrinksDdpthNewShow === 'D' }">
      <div class="block-header a-3-bd a-21-bg e-2-cl">
        <span class="h4 main-cl">
          <!-- 委托列表 -->
          {{$t('futures.depth.text1')}}
        </span>
        <div class="depath-class gray-cl gray-30-bd" v-if="shrinksDdpthNewShow === 'D'" @click.stop="isShowDepat = !isShowDepat">
          <span class="hoverHide">
            <!-- 深度 -->
            {{$t('futures.depth.text4')}}
            {{ fixDepthNumber(depathList[activeDepat]) }}
            <span class="triangle-down"></span>
          </span>
          <span class="hoverShow b-4-cl">
            <!-- 深度 -->
            {{$t('futures.depth.text4')}}
            {{ fixDepthNumber(depathList[activeDepat]) }}
            <span class="triangle-down b-4-bd"></span>
          </span>
          <ul class="type-item a-21-bg" v-if="isShowDepat">
            <template  >
              <li
                v-for="(item, index) in depathList"
                :key="index"
                :class="(activeDepat === index || depatHover === index) ? 'a-3-bg main-cl' : ''"
                @mouseenter="handMouseenter(index)"
                @mouseout="handMouseleave(index)"
                @click.stop="switchDepat(index)">
                {{ fixDepthNumber(item) }}
              </li>
            </template>
          </ul>
        </div>
      </div>

      <div class="block-content">
        <tableList
          type="asks"
          :theadList="theadList"
          :dataList="dataList.asksData"
          :maxValue="dataList.depthMaxNumber"
          :cellWidth="cellWidth"
          :lineNumber="sellLineNumber"
          :bodyHeight="sellHeight"
        />
        <div class="current-price main-bg">
          <div class="price-box">
            <span class="indexPrice" :class="fixUpDownColor(priceClsss)">{{ thousandsComma(activePrice) }}
             <i v-if="priceClsss === 'u-1-cl'">↑</i>
             <i v-if="priceClsss === 'u-4-cl'">↓</i>
            </span>
            <span class="tagPrice gray-cl">
              <i class="">
                {{ thousandsComma(publicMarkertInfo.tagPrice) }}
              </i>
              <!-- 标价价格 -->
              {{$t('futures.depth.text5')}}
            </span>
          </div>
        </div>
        <tableList
          type="buy"
          :dataList="dataList.buyData"
          :maxValue="dataList.depthMaxNumber"
          :lineNumber="buyLineNumber"
          :cellWidth="cellWidth"
          :bodyHeight="buyHeight"
        />
      </div>
    </div>

    <!-- 实时成交 -->
    <div class="tab-item" :class="{ 'is-show': shrinksDdpthNewShow === 'T' }">
      <new-trade />
    </div>
  </div>
</template>

<script>
import {
  fixD, nul, division, thousandsComma,
  myStorage,
} from '@/utils';
import { fixUpDownColor } from '@/utils/storage';
import tableList from './component/tableList.vue';
// 实时成交
import newTrade from './newTrade.vue';

export default {
  components: {
    tableList,
    newTrade,
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      wsData: {},
      // 当前深度
      activeDepat: myStorage.get('depthValue') || 0,
      depatHover: 0,
      isShowDepat: false,
      // 收起状态 盘口 和 实时成交显示哪个 ？
      shrinksDdpthNewShow: 'D',
      // 卖盘 高度
      sellHeight: 263,
      // 买盘 高度
      buyHeight: 263,
      // 显示条数
      sellLineNumber: 10,
      buyLineNumber: 10,
      // 当前价格
      activePrice: null,
      priceClsss: null,
    };
  },
  computed: {
    lan() {
      return this.$store.state.baseData.lan;
    },
    cellWidth() {
      return this.lan === 'ru_RU' ? [100, 110, 90] : [110, 90, 90];
    },
    // 价格 数量 累计
    theadList() {
      return [
        this.$t('futures.depth.theadList1'), // 价格
        `${this.$t('futures.depth.theadList2')} (${this.coUnit})`, // '数量',
        `${this.$t('futures.depth.theadList3')} (${this.coUnit})`, // '总计',
      ];
    },
    // 当前合约信息
    contractInfo() {
      return this.$store.state.future.contractInfo;
    },
    // 深度级别列表
    depathList() {
      if (this.contractInfo) {
        const d = this.contractInfo.coinResultVo.depth;
        if (d === ['0', '0', '0']) {
          return ['0'];
        }
        return this.contractInfo.coinResultVo.depth;
      }
      return ['3', '2', '1'];
    },
    // 当前币对
    symbolCurrent() {
      return this.$store.state.future.coTypeSymbol;
    },
    // 当前合约面值
    multiplier() {
      return Number(this.$store.state.future.multiplier);
    },
    // 合约数量单位
    coUnit() {
      return this.$store.state.future.coUnit;
    },
    // 数量单位类型Number
    coUnitType() {
      return this.$store.state.future.coUnitType;
    },
    // 合约数量精度
    volfix() {
      return this.$store.state.future.volfix;
    },
    // 合约币对价格精度
    pricefix() {
      return this.$store.state.future.pricefix;
    },
    // 标记价格、指数价格、资金费率
    publicMarkertInfo() {
      const { publicMarkertInfo } = this.$store.state.future;
      if (publicMarkertInfo) {
        return {
          // 标记价格
          tagPrice: this.fixPrice(publicMarkertInfo.tagPrice),
          // 指数价格
          indexPrice: this.fixPrice(publicMarkertInfo.indexPrice),
        };
      }
      return {
        indexPrice: '--',
      };
    },
    dataList() {
      if (this.wsData) {
        const data = this.wsData;
        const dataTypeKey = Object.keys(data);
        const depthListData = {};
        let maxTotal = 0;
        if (dataTypeKey.length) {
          dataTypeKey.forEach((item) => {
            const objItem = data[item];
            let totalNum = 0;
            let maxval = 0;
            const dataArr = [];
            let objKeys = null;
            if (item === 'asks') {
              objKeys = Object.keys(objItem).sort((a, b) => a - b);
            } else {
              objKeys = Object.keys(objItem).sort((a, b) => b - a);
            }
            // 去掉 价格为零的
            objKeys.forEach((itemKey) => {
              const itemArr = objItem[itemKey];
              if (dataArr.length < 10) {
                // 获取最大的数量
                maxval = maxval < itemArr[1] ? itemArr[1] : maxval;
                totalNum += itemArr[1];
                let total = totalNum;
                let vol = itemArr[1];
                // 标的货币
                if (this.coUnitType === 1 && totalNum && this.multiplier) {
                  total = fixD(nul(totalNum, this.multiplier), this.volfix);
                  vol = fixD(nul(vol, this.multiplier), this.volfix);
                }
                const objd = {
                  // 总量
                  total,
                  // 价格
                  price: fixD(itemArr[0], this.pricefix),
                  // 数量
                  vol,
                  // 是否有变化
                  diff: itemArr[2],
                };
                // 处理增量数据
                if (data.newData && data.newData.indexOf(itemArr[0]) < 0) {
                  objd.diff = 0;
                }
                if (vol > 0) {
                  dataArr.push(objd);
                }
              }
            });
            depthListData[item] = dataArr;
            if (maxTotal < maxval) {
              maxTotal = maxval;
            }
          });
          let asksMaxValue = 0;
          let buysMaxValue = 0;
          if (depthListData.asks && depthListData.asks.length) {
            const index = depthListData.asks.length - 1;
            asksMaxValue = depthListData.asks[index].total;
          }
          if (depthListData.buys && depthListData.buys.length) {
            const index = depthListData.buys.length - 1;
            buysMaxValue = depthListData.buys[index].total;
          }
          const maxTotalValue = Math.max(asksMaxValue, buysMaxValue);
          return {
            depthMaxNumber: maxTotalValue,
            asksData: depthListData.asks && depthListData.asks.reverse(),
            buyData: depthListData.buys,
          };
        }
      }
      return {
        asksData: [],
        buyData: [],
        depthMaxNumber: null,
      };
    },
    //  买一 买价盘口最靠近当前价的
    buyOne() {
      if (this.dataList && this.dataList.buyData && this.dataList.buyData.length) {
        return this.swNumber(this.dataList.buyData[0].price);
      }
      return 0;
    },
    // 卖一 卖价盘口最靠近当前价的
    sellOne() {
      if (this.dataList && this.dataList.asksData && this.dataList.asksData.length) {
        return this.swNumber(this.dataList.asksData[this.dataList.asksData.length - 1].price);
      }
      return 0;
    },
    // 获取当前合约最新价格（下单模块使用）
    activeNewPrice() {
      let value = 0;
      if (this.buyOne && this.sellOne && this.activePrice) {
        value = this.medianValue(this.buyOne, this.sellOne, this.activePrice);
      } else if (!this.buyOne && this.sellOne && this.activePrice) {
        value = this.meanValue(this.sellOne, this.activePrice);
      } else if (this.buyOne && !this.sellOne && this.activePrice) {
        value = this.meanValue(this.buyOne, this.activePrice);
      } else if (this.buyOne && this.sellOne && !this.activePrice) {
        value = this.meanValue(this.buyOne, this.sellOne);
      } else {
        const arr = [this.buyOne, this.sellOne, this.activePrice];
        arr.forEach((item) => {
          if (item) {
            value = item;
          }
        });
      }
      return value;
    },
  },
  watch: {
    // activeNewPrice(val) {
    //   this.$bus.$emit('ACTIVE_NEW_PRICE', val);
    //   this.$bus.$emit('ACTIVE_BUY_ONE_PRICE', this.buyOne);
    //   this.$bus.$emit('ACTIVE_SELL_ONE_PRICE', this.sellOne);
    //   this.$bus.$emit('ACTIVE_ACTIVE_PRICE', this.activePrice);
    // },
    buyOne: {
      immediate: true,
      handler(val) {
        this.$bus.$emit('ACTIVE_BUY_ONE_PRICE', val);
      },
    },
    sellOne: {
      immediate: true,
      handler(val) {
        this.$bus.$emit('ACTIVE_SELL_ONE_PRICE', val);
      },
    },
    activePrice: {
      immediate: true,
      handler(val) {
        this.$bus.$emit('ACTIVE_ACTIVE_PRICE', val);
      },
    },
  },
  methods: {
    fixUpDownColor,

    init() {
      // 监听 深度数据
      this.$bus.$on('DEPTH_DATA', (data) => {
        if (data.symbol) {
          return;
        }
        this.wsData = data;
      });
      this.$bus.$on('activeWsData', (data) => {
        if (data.close && data.close !== '--') {
          this.activePrice = Number(data.close);
        } else {
          this.activePrice = '--';
        }
        this.priceClsss = data.class;
      });
      this.$bus.$on('GET_DEPTH_INFO', () => {
        this.$bus.$emit('ACTIVE_BUY_ONE_PRICE', this.buyOne);
        this.$bus.$emit('ACTIVE_SELL_ONE_PRICE', this.sellOne);
        this.$bus.$emit('ACTIVE_ACTIVE_PRICE', this.activePrice);
      });
    },
    // 新价精度
    fixPrice(value) {
      if (value) {
        return fixD(value, this.pricefix);
      }
      return '--';
    },
    fixDepthNumber(val) {
      if (val === 0 || val === '0') {
        return 1;
      }
      if (val === 1 || val === '1') {
        return 0.1;
      }
      const n = Number(val) - 1;
      const num = 0;
      const b = num.toFixed(n);
      return `${b}1`;
    },
    // 盘口 和 实时成交 切换
    switchBlock(type) {
      this.shrinksDdpthNewShow = type;
    },
    handMouseenter(id) {
      this.depatHover = id;
    },
    switchDepat(id) {
      this.activeDepat = id;
      this.isShowDepat = false;
      myStorage.set('depthValue', this.activeDepat);
      this.$bus.$emit('DEPTH_VALUE', this.activeDepat);
    },
    handMouseleave() {
      this.depatHover = '';
    },
    // 转数字
    swNumber(val) {
      if (parseFloat(val).toString() !== 'NaN') {
        return parseFloat(val);
      }
      return false;
    },
    // 三个数获取中间值
    medianValue(a, b, c) {
      if ((b - a) * (a - c) >= 0) {
        return a;
      } if ((a - b) * (b - c) >= 0) {
        return b;
      }
      return c;
    },
    // 两个数获取平均
    meanValue(a, b) {
      return division(a + b, 2);
    },
    thousandsComma(num) {
      if (num) {
        return thousandsComma(num);
      }
      return num;
    },
  },
};
</script>
<style scoped lang="scss">
.codepath-container {
  .coDepth {
    position: relative;
    overflow: hidden;
  }

  .block-header {
    height: 34px;
    line-height: 32px;
    padding: 0 15px;
    font-size: 14px;
    // border-bottom-width: 1px;
    // border-bottom-style: solid;
    margin-bottom: 1px;
    z-index: 10;
    position: relative;
  }

  .tab-item {
    display: none;
    margin-bottom: 5px;
    .block-header {
      display: none;
    }

    &.is-show {
      display: block;
    }
  }

  .current-price {
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    font-size: 12px;
    margin-top: 0;

    .price-box {
      height: 40px;
      line-height: 40px;
      font-size: 12px;

      span {
        vertical-align: middle;
        min-width: 100px;
        display: inline-block;
        box-sizing: border-box;
      }

      .price {
        margin-right: 10px;
      }

      .indexPrice {
        font-size: 14px;
        margin-right: 15px;
      }
    }

    .jb {
      margin-left: 10px;
      display: inline-block;
      float: right;

      i {
        vertical-align: middle;
        display: inline-block;
        width: 6px;
        margin-right: 3px;
        height: 14px;
        border-width: 1px;
        border-style: solid;
        border-radius: 2px;
      }
    }
  }

  .title-tab {
    .tab {
      display: inline-block;
      border-bottom-style: solid;
      border-bottom-width: 0;
      height: 33px;
      cursor: pointer;
      user-select: none;
      margin-right: 28px;
      font-size: 14px;
      position: relative;

      .selected {
        width: 10px;
        height: 2px;
        position: absolute;
        left: 50%;
        bottom: -1px;
        transform: translateX(-50%);
        display: block;
      }
    }

    .tab-rtwo {
      margin: 0;
    }
  }

  .depath-class {
    float: right;
    position: relative;
    cursor: pointer;
    border-width: 1px;
    border-style: solid;
    border-radius: 2px;
    font-family: 'Alpex';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    padding: 2px 8px;
    height: 19px;
    line-height: 19px;
    margin-top: 4px;

    span {
      user-select: none;
    }

    ul {
      display: none;
      position: absolute;
      top: 24px;
      right: 0;
      width: 100%;
      text-align: right;

      li {
        height: 24px;
        line-height: 24px;
        padding: 0 10px;
        cursor: pointer;
        margin-bottom: 1px;
      }
    }

    .hoverShow {
      display: none;
    }

    &:hover {
      .hoverHide {
        display: none;
      }

      .hoverShow {
        display: block;
      }

      ul {
        display: block;
      }
    }
  }

  // 如果宽度大于 1820px
  @media screen and (min-width: 1820px){
    .title-tab {
      display: none;
    }

    .tab-item {
      display: block;

      .block-header {
        display: block;
      }
    }
  }

  .triangle-down {
      width: 0;
      height: 0;
      border-left: 6px solid transparent !important;
      border-right: 6px solid transparent !important;
      border-top-width: 5px;
      border-top-style: solid;
      margin: 0;
      vertical-align: middle;
      padding: 0;
      display: inline-block;
    }

  .icon-triangle-down {
    font-size: 8px;
    margin-left: 5px;
    margin-bottom: 1px;
  }
}
</style>
